import { toMomentFromUtc } from 'api/helpers';

export default class OrderStatusItem {
	date = null;
	type = null;
	total = null;
	po_number = null;
	po_number_sort = null;
	ship_to_name = null;

	constructor(order) {
		this.date = toMomentFromUtc(order.OrderDate);
		this.type = order.Type;
		this.total = order.Total;
		this.po_number = order.PoNumber;
		this.po_number_sort = order.PoNumber;
		this.ship_to_name = order.ShipToName;
	}
}



// WEBPACK FOOTER //
// ./src/api/models/OrderStatusItem.js